// extracted by mini-css-extract-plugin
export default {"textPrimary":"#222","textPlaceholder":"#a9a9aa","surface5":"#fff","surface2":"#e6e6e6","mainFontRegular":"DMSans-Regular,sans-serif"};